import dayjs from "dayjs";
import { forwardRef } from "react";

export const ComponentToPrintList = forwardRef((props, ref) => {

  return (<div ref={ref} style={{ padding: "20px 20px" }}>
    <table>
      <tr>
        <th style={{ fontSize: "12px", padding: "5px", borderBottom: "#000 1px solid" }}>Booking Id</th>
        <th style={{ fontSize: "12px", padding: "5px", borderBottom: "#000 1px solid" }}>Post Code</th>
        <th style={{ fontSize: "12px", padding: "5px", borderBottom: "#000 1px solid" }}>Driver Name</th>
        <th style={{ fontSize: "12px", padding: "5px", borderBottom: "#000 1px solid" }}>Address</th>
        <th style={{ fontSize: "12px", padding: "5px", borderBottom: "#000 1px solid" }}>Contact No</th>
        <th style={{ fontSize: "12px", padding: "5px", borderBottom: "#000 1px solid" }}>Date</th>
        <th style={{ fontSize: "12px", padding: "5px", borderBottom: "#000 1px solid" }}>Assigned Date</th>
      </tr>
      {props?.data?.map((row) => {
        return (<tr>
          <td style={{ fontSize: "12px", padding: "5px", borderBottom: "#000 1px solid" }}>{row?.booking_id}</td>
          <td style={{ fontSize: "12px", padding: "5px", borderBottom: "#000 1px solid" }}>{row?.post_code}</td>
          <td style={{ fontSize: "12px", padding: "5px", borderBottom: "#000 1px solid" }}>{row?.driver?.name}</td>
          <td style={{ fontSize: "12px", padding: "5px", borderBottom: "#000 1px solid" }}>{row?.pickup_details?.address}</td>
          <td style={{ fontSize: "12px", padding: "5px", borderBottom: "#000 1px solid" }}>{row?.pickup_details?.phone}</td>
          <td style={{ fontSize: "12px", padding: "5px", borderBottom: "#000 1px solid" }}>{dayjs(row?.pickup_date).format("DD/MM/YYYY")}</td>
          <td style={{ fontSize: "12px", padding: "5px", borderBottom: "#000 1px solid" }}>{dayjs(row?.driver?.assigned_date).format("DD/MM/YYYY")}</td>
        </tr>);
      })}
    </table>
  </div>);
});